// Uses libphonenumber-js to validate international numbers (expects +countrycode...)
import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js/min'

export function isPhoneNumber(input) {
  if (input == null || input === '') return true
  try {
    return isValidPhoneNumber(String(input))
  } catch (_) {
    return false
  }
}

export function composeE164(prefix, national) {
  const p = normalizePrefix(prefix)
  const n = normalizeNational(national)
  if (!p && !n) return ''
  return `${p}${n}`
}

export function splitE164(e164) {
  if (!e164) return { prefix: '', national: '' }
  const parsed = parsePhoneNumberFromString(String(e164))
  if (parsed && parsed.isValid()) {
    return {
      prefix: `+${parsed.countryCallingCode}`,
      national: parsed.nationalNumber || '',
    }
  }
  // Fallback best-effort split: take leading +digits as prefix, rest as national
  const m = String(e164).match(/^(\+[1-9]\d{0,3})(\d*)$/)
  if (m) {
    return { prefix: m[1], national: m[2] }
  }
  return { prefix: '', national: '' }
}

export function normalizePrefix(prefix) {
  let p = String(prefix || '')
    .trim()
    .replace(/\s+/g, '')
  if (!p) return ''
  // convert 00 to + and keep only digits after +
  if (p.startsWith('00')) p = '+' + p.slice(2)
  if (!p.startsWith('+')) p = '+' + p
  p = '+' + p.replace(/^\+/, '').replace(/\D/g, '')
  return p
}

export function normalizeNational(national) {
  return String(national || '').replace(/\D/g, '')
}
